<template>
<div>
    <van-nav-bar :left-arrow="true" left-text="返回" title="连锁模式" fixed :placeholder="true" @click-left="goBack">
        <van-icon v-if="this.configId" name="delete" slot="right" @click="deleteRule" />
    </van-nav-bar>
    <div>
        <!-- <van-cell is-link title="连锁影院" @click="showGplineSelect(false)">
            <template #value>
                <span :style="{ color: getGplineColor() }">
                    {{ ruleInfo.gp_line_desc }}
                </span>
            </template>
        </van-cell> -->
        <van-cell is-link :value="ruleInfo.gp_line_desc || '请选择院线范围'" @click="showGplineSelect(false)" :class="getGplineColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">院线</span>
                <span style="color: red; margin-left: 2px;">*</span>
            </template>
        </van-cell>
    </div>
    <div style="margin-top: 20px;">
        <van-cell title="规则名称" style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">规则名称</span>
                <span style="color: red; margin-left: 2px;">*</span>
            </template>
            <van-field v-model="ruleInfo.name" placeholder="请输入规则名称" rows="1" right clearable style="display: flex;justify-content: right;text-align: right;" />
        </van-cell>
        <!-- <van-cell is-link title="不包含省" :value="ruleInfo.exclude_province_desc" @click="showProvinceSelect(2)"> -->
        <!-- </van-cell> -->
        <van-cell is-link :value="ruleInfo.city_desc || '不限'" @click="showCitySelect()" :class="getCityColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">城市</span>
            </template>
        </van-cell>
        <!-- <van-cell is-link title="包含影院" :value="ruleInfo.include_cinema_desc" @click="showCinemaSelect(1)">
        </van-cell>
        <van-cell is-link title="不包含影院" :value="ruleInfo.exclude_cinema_desc" @click="showCinemaSelect(2)">
        </van-cell> -->
        <!-- <van-field v-model="ruleInfo.name" label="规则名称" placeholder="请输入规则名称" rows="1" right clearable/> -->
        <!-- <van-cell is-link title="包含省" :value="ruleInfo.include_province_desc" @click="showProvinceSelect(1)">
        </van-cell>
        
        <van-cell is-link title="包含品牌" :value="ruleInfo.line_name" @click="showGplineSelect(true)"></van-cell> -->
    </div>
    <div style="margin-top: 20px;">
        <van-cell is-link :value="ruleInfo.cinema_desc || '不限'" @click="showCinemaSelect()" :class="getCinemaColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">影院</span>
            </template>
        </van-cell>
        <van-cell is-link :value="ruleInfo.class_desc || '不限'" @click="showClassSelect()" :class="getClassColorClass()">
            <template slot="title">
                <span style="font-weight: bold;">影院分类</span>
            </template>
        </van-cell>
        <!-- <van-cell is-link title="包含影厅" :value="ruleInfo.include_hall_desc" @click="showHallSelect(1)">
        </van-cell>
        <van-cell is-link title="不包含影厅" :value="ruleInfo.exclude_hall_desc" @click="showHallSelect(2)">
        </van-cell>
        <van-cell is-link title="包含电影" :value="ruleInfo.include_movie_desc" @click="showMovieSelect(1)">
        </van-cell>
        <van-cell is-link title="不包含电影" :value="ruleInfo.exclude_movie_desc" @click="showMovieSelect(2)">
        </van-cell> -->
    </div>

    <van-cell-group style="margin-top: 20px;">
        <van-cell>
            <template slot="title">
                <span class="margin-right5 vertical-middle" style="font-weight: bold;">包含影厅</span>
                <van-tag type="danger">填写即生效，可不填写</van-tag>
            </template>

        </van-cell>
        <van-cell style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">普通</span>
            </template>
            <van-field v-model="ruleInfo.normal_price" placeholder="固定价格" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />
        </van-cell>
        <van-cell style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">IMAX</span>
            </template>
            <van-field v-model="ruleInfo.imax_price" placeholder="固定价格" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />
        </van-cell>
        <van-cell style="display: flex;align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">VIP</span>
            </template>
            <van-field v-model="ruleInfo.vip_price" placeholder="固定价格" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />
        </van-cell>
        <van-cell is-link style="display: flex;align-items: center;" value="点击设置" @click="showSpecialPrice">
            <template slot="title">
                <span style="font-weight: bold;">特殊</span>
            </template>
        </van-cell>
    </van-cell-group>

    <!-- <van-cell-group style="margin-top: 20px;">
        <van-cell title="市场价" style="display: flex;align-items: center;">
            <van-row style="display: flex;align-items: center;">
                <van-field v-model="ruleInfo.begin_price" placeholder="最低" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />
                <hr style="width: 16px; margin: 0px 0; border: 0; border-top: 1px solid #0a0a0a;" />

                <van-field v-model="ruleInfo.end_price" placeholder="最高" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" />

            </van-row>
        </van-cell>
        <van-cell title="放映时间" style="display: flex; align-items: center;">
            <van-row style="display: flex;align-items: center;">
                <van-field v-model="ruleInfo.begin_time" placeholder="开始" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeTime(1)" />
                <hr style="width: 16px; margin: 0px 0; border: 0; border-top: 1px solid #0a0a0a;" />

                <van-field v-model="ruleInfo.end_time" placeholder="结束" rows="1" clearable style="width: 100%; border: 1px solid #ebedf0; border-radius: 4px;" @click="changeTime(2)" />

            </van-row>

        </van-cell>
        <van-cell is-link title="包含星期" :value="ruleInfo.week_desc" @click="showWeekSelect">
        </van-cell>
    </van-cell-group> -->

    <van-cell-group style="margin-top: 20px;">
        <van-cell reverse-color class="ticket-count-cell">
            <template slot="title">
                <span style="font-weight: bold;">票数</span>
            </template>
            <van-checkbox-group v-model="ruleInfo.ticket_num" @change="handleTicketCountChange" style="display: flex; flex-wrap: wrap; justify-content: space-around;">
                <van-checkbox :name="0" style="margin: 4px;" @click.native="lastClick(0)">全部</van-checkbox>
                <van-checkbox :name="1" style="margin: 4px;" @click.native="lastClick(1)">1张</van-checkbox>
                <van-checkbox :name="2" style="margin: 4px;" @click.native="lastClick(2)">2张</van-checkbox>
                <van-checkbox :name="3" style="margin: 4px;" @click.native="lastClick(3)">3张</van-checkbox>
                <van-checkbox :name="4" style="margin: 4px;" @click.native="lastClick(4)">4张</van-checkbox>
            </van-checkbox-group>
            <!-- <div style="margin-top: 10px; font-size: 12px; color: #666;">
                已选择：{{ selectedTicketCountText }}
            </div> -->
        </van-cell>
        <van-cell reverse-color class="couple-seat-cell">
            <template slot="title">
                <span style="font-weight: bold;">情侣座</span>
            </template>
            <van-radio-group v-model="ruleInfo.seat_tag" style="display: flex; justify-content: flex-start; gap: 15px;">
                <van-radio :name="'1'" style="font-size: 13px;">包含情侣座</van-radio>
                <van-radio :name="'2'" style="font-size: 13px;">不含情侣座</van-radio>
            </van-radio-group>
        </van-cell>
    </van-cell-group>

    <van-cell-group style="margin-top: 20px;">
        <van-cell style="display: flex; align-items: center;">
            <template slot="title">
                <span style="font-weight: bold;">启动状态</span>
            </template>
            <van-switch slot="right-icon" :value="ruleInfo.status === 1" @change="setStatus" />
        </van-cell>
    </van-cell-group>

    <div style="padding: 40px 10px;">
        <van-button round type="danger" style="width: 100%;" @click="saveConfig" :loading="isSaving" :disabled="isSaving">
            {{ isSaving ? '保存中...' : '保存条件' }}
        </van-button>
    </div>

    <!--城市弹窗-->
    <van-popup v-model="selectCity" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
                    <van-row style="display: flex;justify-content: center;align-items: center;">
            <span style="font-size: 16px;font-weight: bold;">选择城市</span>
        </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入城市" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearCityClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCityClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <van-tree-select height="500px" :items="filterCityList" :main-active-index.sync="activeIndex" style="padding-bottom: 60px;">
            <template slot="content">
                <van-row v-for="(city, index) in (filterCityList[activeIndex] && filterCityList[activeIndex].city_list ? filterCityList[activeIndex].city_list : [])" :key="index" style="background-color: white;margin-bottom: 10px;">
                    <van-cell :title="city.name" class="cell-with-margin">
                        <template #right-icon>
                            <van-checkbox v-model="city.checked" shape="square" @click="toggleCity(index)"></van-checkbox>
                        </template>
                    </van-cell>
                </van-row>

            </template>
        </van-tree-select>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="6">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</van-col>
            <van-col span="18" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="default" @click="resetCity" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveCityExclude" class="action-btn">排除</van-button>
                <van-button type="primary" size="small" @click="saveCity" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--省份弹窗-->
    <van-popup v-model="selectProvince" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <span style="font-size: 16px;font-weight: bold;">{{ selectProvinceTitle }}</span>
            </van-row>
        </div>
        <!-- <van-row>
                    <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入品牌名" v-model="searchText" :clearable=false>
                        <template #right-icon>
                            <van-row style="display: flex;justify-content: center;align-items: center;">
                                <van-icon v-if="searchText !== ''" name="clear" @click="clearProvinceClick" />
                                <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchProvinceClick">搜索</van-button>
                            </van-row>
        
                        </template>
                    </van-search>
                </van-row> -->
        <div style="height: 320px; overflow: scroll;padding: 15px;">
            <van-row style="flex-wrap: wrap; margin: -6px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(province, index) in filterProvinceList" :key="index" class="custom-checkbox" :class="{ 'checked': province.checked }" @click="provinceCheck(index)" style="margin: 6px;">
                    {{ province.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="7">
                <span style="color: #07c160;font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</span>
            </van-col>
            <van-col span="17" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="danger" @click="resetProvince" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveProvince" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--品牌弹窗-->
    <van-popup v-model="selectGpline" position="bottom">
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <span style="font-size: 16px;font-weight: bold;">选择院线</span>
            </van-row>
        </div>

        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入品牌名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearGplineClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchGplineClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 320px; overflow: scroll;padding: 10px 10px 60px 10px">
            <van-row style="flex-wrap: wrap; margin: -6px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="gplineCheck(index)" style="margin: 6px;">
                    {{ gpline.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="7">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</span>
            </van-col>
            <van-col span="17" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="default" @click="resetGpline" class="action-btn">重置</van-button>
                <van-button type="primary" size="small" @click="saveGpline" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--影院弹窗-->
    <van-popup round v-model="selectCinema" position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
                    <van-row style="display: flex;justify-content: center;align-items: center;">
            <van-col span="24" style="text-align: center;">选择影院</van-col>
        </van-row>
        </div>
        <van-dropdown-menu>
            <van-dropdown-item :title="selectCinemaFilterCityText" ref="selectCinemafilterCity">
                <van-row>
                    <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入城市" v-model="searchText" :clearable=false>
                        <template #right-icon>
                            <van-row style="display: flex;justify-content: center;align-items: center;">
                                <van-icon v-if="searchText !== ''" name="clear" @click="clearCityClick" />
                                <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCityClick">搜索</van-button>
                            </van-row>

                        </template>
                    </van-search>
                </van-row>
                <van-tree-select :items="filterCityList" :main-active-index.sync="activeIndex" style="height: 400px; overflow: scroll;padding: 8px 8px 60px 8px">
                    <template slot="content">
                        <van-row v-for="(city, index) in (filterCityList[activeIndex] && filterCityList[activeIndex].city_list ? filterCityList[activeIndex].city_list : [])" :key="index" style="background-color: white;">
                            <van-cell :title="city.name" class="cell-with-margin">
                                <template #right-icon>
                                    <van-checkbox v-model="city.checked" shape="square" @click="toggleCity(index)"></van-checkbox>
                                </template>
                            </van-cell>
                        </van-row>

                    </template>
                </van-tree-select>
                <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
                    <van-col span="7">
                        <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</span>
                    </van-col>
                    <van-col span="17" style="text-align: right;" class="button-group">
                        <van-button plain size="small" type="danger" @click="resetFilterCity" class="action-btn">重置</van-button>
                        <van-button type="danger" size="small" @click="saveFiterCity" class="action-btn">选择</van-button>
                    </van-col>
                </van-row>
            </van-dropdown-item>
            <van-dropdown-item ref="selectCinemafilterGpline" :title="selectCinemaFilterGplineText">
                <van-row>
                    <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入品牌名" v-model="searchText" :clearable=false>
                        <template #right-icon>
                            <van-row style="display: flex;justify-content: center;align-items: center;">
                                <van-icon v-if="searchText !== ''" name="clear" @click="clearGplineClick" />
                                <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchGplineClick">搜索</van-button>
                            </van-row>

                        </template>
                    </van-search>
                </van-row>
                <div style="height: 400px; overflow: scroll;padding: 8px 8px 60px 8px">

                    <van-row style="flex-wrap: wrap; margin: -6px;">

                        <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="selectCinemaFilterGplineCheck(index)" style="margin: 6px;font-size: small;">
                            {{ gpline.label }}
                        </div>
                    </van-row>
                </div>
                <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
                    <van-col span="8">
                        <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCinemaFilterGplineCount}}</span>个院线</span>
                    </van-col>
                    <van-col span="16" style="text-align: right;">
                        <van-button plain size="small" type="danger" @click="resetFilterGpline">重 置</van-button>
                    </van-col>
                </van-row>
            </van-dropdown-item>
        </van-dropdown-menu>

        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影院名" v-model="searchCinemaText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchCinemaText !== ''" name="clear" @click="clearCinemaClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchCinemaClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 420px; overflow: scroll;padding: 10px;">
            <van-list v-model="loading" :error.sync="error" error-text="请求失败，点击重新加载" :offset="50" @load="onLoad">
                <div v-for="(cinema, index) in filterCinemaList" :key="index" style="padding: 5px; font-size: small;">
                    <van-checkbox v-model="cinema.checked" @click="toggleCinema(index)">{{ cinema.city_name }} · {{ cinema.name }}</van-checkbox>
                </div>
                <!-- <van-cell v-for="item in list" :key="item" :title="item" /> -->
            </van-list>
            <!-- <van-row style="flex-wrap: wrap; margin: -8px;">
            
                                <div v-for="(gpline, index) in filterGplineList" :key="index" class="custom-checkbox" :class="{ 'checked': gpline.checked }" @click="selectCinemaFilterGplineCheck(index)" style="margin: 8px;">
                                    {{ gpline.label }} 
                                </div>
                            </van-row> -->
        </div>
        <!-- <van-row type="flex" justify="space-between" style="font-size: 12px;padding: 10px 0px 10px 0px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="5" @click="onCinemaClick">
                <div style="text-decoration: underline;cursor: pointer;color:blue">{{ selectCinemaText }}</div>
            </van-col>
            <van-col span="12" class="bottom-row" style="text-align: right;">
                <van-button plain size="small" type="danger" @click="resetCinema">重 置</van-button>
                <van-button type="danger" size="small" style="margin-left: 30px;" @click="saveCinema">确认选择</van-button>
            </van-col>
        </van-row> -->
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="7">
                <span style="font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCinemaCount}}</span>个</span>
            </van-col>
            <van-col span="17" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="default" @click="resetCinema" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveCinemaExclude" class="action-btn">排除</van-button>
                <van-button type="primary" size="small" @click="saveCinema" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!-- 影院分类弹窗 -->
    <van-popup v-model="selectClass" position="bottom" round class="class-popup">
        <div class="class-popup-head">
            <span class="class-popup-title">选择影院分类</span>
            <span class="class-popup-hint">已选 {{ filterClassList.filter(c => c.checked).length }} 项</span>
        </div>
        <div class="class-popup-body">
            <van-loading v-if="classListLoading" type="spinner" size="24px" vertical class="class-popup-loading">加载中</van-loading>
            <template v-else>
                <div
                    v-for="(item, index) in filterClassList"
                    :key="item.id"
                    class="class-popup-item"
                    :class="{ 'is-checked': item.checked }"
                    @click="toggleClassCheck(index)"
                >
                    <span class="class-popup-item-name">{{ item.name }}</span>
                    <van-icon v-if="item.checked" name="success" class="class-popup-item-icon" />
                </div>
                <div v-if="filterClassList.length === 0" class="class-popup-empty">暂无可选分类</div>
            </template>
        </div>
        <div class="class-popup-foot">
            <button type="button" class="class-popup-btn class-popup-btn--reset" @click="resetClass">重置</button>
            <button type="button" class="class-popup-btn class-popup-btn--exclude" @click="saveClassAsExclude">排除</button>
            <button type="button" class="class-popup-btn class-popup-btn--include" @click="saveClassAsInclude">包含</button>
        </div>
    </van-popup>

    <van-action-sheet v-model="showSelectCinema" :actions="selectCinemaList" description="已选中的影院" />

    <!--影厅弹窗-->
    <van-popup v-model="selectHall" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">{{ selectHallTitle }}</van-col>
            </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影厅名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearHallClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchHallClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 350px; overflow: scroll;padding: 10px;">
            <van-row style="flex-wrap: wrap; margin: -6px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(hall, index) in filterHallList" :key="index" class="custom-checkbox" :class="{ 'checked': hall.checked }" @click="hallCheck(index)" style="margin: 4px;font-size: 12px;padding: 6px 8px;line-height: 1.2;">
                    {{ hall.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="7">
                <span style="color: #07c160;font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</span>
            </van-col>
            <van-col span="17" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="danger" @click="resetHall" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveHall" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--影片弹窗-->
    <van-popup v-model="selectMovie" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">{{ selectMovieTitle }}</van-col>
            </van-row>
        </div>
        <van-row>
            <van-search style="width: 100%;display: flex;justify-content: center;align-items: center;" placeholder="请输入影片名" v-model="searchText" :clearable=false>
                <template #right-icon>
                    <van-row style="display: flex;justify-content: center;align-items: center;">
                        <van-icon v-if="searchText !== ''" name="clear" @click="clearMovieClick" />
                        <van-button style="margin-left: 20px;" size="small" type="info" round=true @click="searchMovieClick">搜索</van-button>
                    </van-row>

                </template>
            </van-search>
        </van-row>
        <div style="height: 500px; overflow: scroll;padding: 8px;">
            <van-row style="flex-wrap: wrap; margin: -4px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(movie, index) in filterMovieList" :key="index" class="custom-checkbox" :class="{ 'checked': movie.checked }" @click="movieCheck(index)" style="margin: 4px;font-size: 12px;padding: 6px 8px;line-height: 1.2;">
                    {{ movie.label }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" class="bottom-row" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="7">
                <span style="color: #07c160;font-weight: bold;">已选择<span style="color: red;font-weight: bold;">{{selectCount}}</span>个</span>
            </van-col>
            <van-col span="17" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="danger" @click="resetMovie" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveMovie" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>
    <van-popup v-model="selectTime" round position="bottom">
        <van-datetime-picker style="height: 400px; overflow: scroll;padding: 15px;" v-model="currentTime" type="time" :min-hour="0" :max-hour="23" @confirm="timeCheck" @cancel="selectTime = false" />
    </van-popup>

    <!--星期弹窗-->
    <van-popup v-model="selectWeek" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">添加包含星期</van-col>
            </van-row>
        </div>
        <div style="height: 320px; overflow: scroll;padding: 15px;">
            <van-row style="flex-wrap: wrap; margin: -8px;">
                <!-- 使用 flex-wrap 使子元素换行 -->
                <div v-for="(week, index) in filterWeekList" :key="index" class="custom-checkbox" :class="{ 'checked': week.checked }" @click="weekCheck(index)" style="margin: 8px;font-size: small;">
                    {{ week.name }} <!-- 显示复选框的序号 -->
                </div>
            </van-row>
        </div>
        <van-row type="flex" justify="space-between" style="font-size: 12px;padding: 10px;background-color: rgb(230, 197, 174);display: flex; align-items: center;">
            <van-col span="6">已选择{{selectCount}}个</van-col>
            <van-col span="18" style="text-align: right;" class="button-group">
                <van-button plain size="small" type="danger" @click="resetWeek" class="action-btn">重置</van-button>
                <van-button type="danger" size="small" @click="saveWeek" class="action-btn">选择</van-button>
            </van-col>
        </van-row>
    </van-popup>

    <!--特殊厅价格设置-->
    <van-popup v-model="specialPrice" round position="bottom">
        <!--弹框标题-->
        <div style="background-color: #f5f5f5;padding: 15px;">
            <van-row style="display: flex;justify-content: center;align-items: center;">
                <van-col span="24" style="text-align: center;">设置影厅报价</van-col>
                <van-col span="2" style="display: flex;align-items: right;">
                    <van-icon name="plus" color="blue" @click="showHall" />
                </van-col>

            </van-row>

        </div>

        <div ref="hallSettting" style="height: 480px; overflow: scroll;padding: 10px;">
            <van-row v-for="(hall, index) in filterHallList" :key="index" style="background-color: white;margin-bottom: 10px;">
                <van-cell :title="hall.hall_name" style="display: flex;align-items: center;">
                    <van-row style="display: flex;align-items: center;">
                        <van-field v-model="hall.price" placeholder="请输入固定价格" rows="1" clearable style="width: 90%; border: 1px solid #ebedf0; border-radius: 4px;" />
                        <van-icon v-if="hall.is_user" name="delete" color="red" @click="deleteHall(index)" style="margin-left: 5px;" />
                    </van-row>

                </van-cell>
            </van-row>
        </div>
    </van-popup>

    <van-dialog v-model="showHallSet" title="设置影厅" show-cancel-button :lazy-render="false" @confirm="addHall">
        <van-field v-model="custom_hall_name" clearable maxlength="10" placeholder="请输入影厅名" show-word-limit class="message" />
    </van-dialog>

   

</div>
</template>

<script>
import Api from '@/api-service'

import {
    Dialog
} from 'vant-green';

export default {
    name: "Rule-Custom",
    data() {
        return {
            configId: 0,
            configType: 2,
            copy: 0,
            isSaving: false, // 防止重复提交

            ruleInfo: {
                include_province_desc: '设置包含省',
                include_province_scope: [],

                exclude_province_desc: '设置不包含省',
                exclude_province_scope: [],

                include_city_desc: '设置包含城市',
                include_city_scope: [],

                exclude_city_desc: '设置不包含城市',
                exclude_city_scope: [],
                gp_line: 0,
                line_name: '请选择院线',
                gp_line_scope_type: 1, // 1-不限，2-包含，3-排除
                gp_line_scope: [], // 院线ID数组
                gp_line_desc: '请选择院线范围',

                cinema_desc: '',
                cinema_scope: [],

                class_scope_type: 1, // 1-不限 2-包含 3-排除
                class_scope: [],
                class_desc: '不限',

                hall_name: [],
                include_hall_desc: '设置包含影厅',
                include_hall_scope: [],
                exclude_hall_desc: '设置不包含影厅',
                exclude_hall_scope: [],

                include_movie_desc: '设置包含影片',
                include_movie_scope: [],
                exclude_movie_desc: '设置不包含影片',
                exclude_movie_scope: [],

                begin_price: '',
                end_price: '',

                time_scope: [],
                begin_time: '',
                end_time: '',

                week_desc: '设置包含星期',
                week_days: [],

                ticket_num: [],
                ticket_count_list: [0], // 新的票数列表字段

                // 情侣座规则
                seat_tag: '1', // '1'-包含情侣座，'2'-不包含情侣座

                // 报价类型
                bid_type: 0,
                bid_value: '',

                normal_price: '',
                vip_price: '',
                imax_price: '',

                status: 1,
            },

            bid_type_desc: {
                3: '订单金额的百分比折扣，如填90，则为单价的9折进行自动报价',
                4: '当建议顶价为40时，如填2，则使用38自动报价，支持1位小数',
                5: '如填38，则使用38自动报价，支持1位小数',
                6: '当单价原价为40时，如填2，则使用38自动报价，支持1位小数',
            },

            selectProvince: false,
            selectCity: false,
            selectGpline: false,
            selectCinema: false,

            activeIndex: 0,
            provinceList: [],
            filterProvinceList: [],
            selectProvinceList: [],

            cityList: [],
            filterCityList: [],
            selectCityList: [],

            gpLineList: [],
            filterGplineList: [],
            selectedGpline: 0,

            // searchGplineList: [], // 搜索时，保存的gpLineList

            searchText: '',
            selectCount: 0,
            src: 0,

            // 院线范围类型选择
            gpLineScopeType: 1, // 1-包含，2-排除

            selectCinemaFilterCityNameList: [],
            // selectCinemaFilterCount: 0,
            selectCinemaFilterGplineList: [],
            selectCinemaFilterGplineCount: 0,

            searchCinemaText: '',
            cinemaList: [],
            filterCinemaList: [],
            selectCinemaList: [],
            selectCinemaNameList: [],
            selectCinemaCount: 0,
            page: 1,
            pageSize: 20,
            loading: false,
            error: false,
            finished: false,
            showSelectCinema: false,

            selectClass: false,
            filterClassList: [],
            classScopeType: 2,
            selectClassList: [],
            classListLoading: false,

            // selectCinemaFilterCityList: [],

            // selectCinemaCityList: [],
            selectCinemaCityCount: 0,

            selectHall: false,
            defaultHallList: [],
            selectHallList: [],
            filterHallList: [],

            // 影片
            selectMovie: false,
            movieList: [],
            selectMovieList: [],
            filterMovieList: [],

            // 时间
            selectTime: false,
            currentTime: '',

            // 星期
            selectWeek: false,
            weekList: [{
                    label: '星期一',
                    value: 1
                },
                {
                    label: '星期二',
                    value: 2
                },
                {
                    label: '星期三',
                    value: 3
                },
                {
                    label: '星期四',
                    value: 4
                },
                {
                    label: '星期五',
                    value: 5
                },
                {
                    label: '星期六',
                    value: 6
                },
                {
                    label: '星期日',
                    value: 7
                }
            ],
            selectWeekList: [],
            filterWeekList: [],

            // 影厅价格设置
            specialPrice: false,
            showHallSet: false,
            custom_hall_name: '',
            lastChecked: null,
            inited: false,
        }
    },
    computed: {
        selectProvinceTitle() {
            if (this.src === 1) {
                return '添加包含省份'
            } else {
                return '添加不包含省份'
            }
        },
        selectCityTitle() {
            if (this.src === 1) {
                return '添加包含城市'
            } else {
                return '添加不包含城市'
            }
        },
        selectCinemaFilterCityText() {
            return `城市(${this.selectCinemaCityCount})`
        },
        selectCinemaFilterGplineText() {
            return `品牌(${this.selectCinemaFilterGplineCount})`
        },
        selectCinemaText() {
            return `已选择 ${this.selectCinemaCount} 个`
        },
        selectCinemaTitle() {
            if (this.src === 1) {
                return '添加包含影院'
            } else {
                return '添加不包含影院'
            }
        },
        selectHallTitle() {
            if (this.src === 1) {
                return '添加包含影厅'
            } else {
                return '添加不包含影厅'
            }
        },
        selectMovieTitle() {
            if (this.src === 1) {
                return '添加包含影片'
            } else {
                return '添加不包含影片'
            }
        },
        priceText(src) {
            if (src == 1) {
                if (this.ruleInfo.begin_price == '') {
                    return '最低'
                } else {
                    return this.ruleInfo.begin_price
                }
            } else {
                if (this.ruleInfo.end_price == '') {
                    return '最高'
                } else {
                    return this.ruleInfo.end_price
                }
            }
        },
        timeText(src) {
            if (src == 1) {
                if (this.ruleInfo.begin_price == '') {
                    return '开始'
                } else {
                    return this.ruleInfo.begin_price
                }
            } else {
                if (this.ruleInfo.end_price == '') {
                    return '结束'
                } else {
                    return this.ruleInfo.end_price
                }
            }
        },

    },
    created() {
        this.configId = this.$route.query.id;
        this.configType = this.$route.query.type;
        this.copy = this.$route.query.copy;
        console.log(this.configId);
        if (this.configId) {
            this.fetchData();
        }

        this.getProvince()
        this.getGpline()

        this.getCinema({
            page: this.page,
            pageSize: this.pageSize,
        })

        this.getHallList()
        // this.getMovieList()
        if (!this.ruleInfo.ticket_num || this.ruleInfo.ticket_num.length === 0) {
            this.ruleInfo.ticket_num = [0];
        }
    },
    methods: {
        fetchData() {
            Api.getConfigDetail({
                id: this.configId
            }).then(res => {
                this.ruleInfo = res
                // if (this.ruleInfo.include_province_scope !== null && this.ruleInfo.include_province_scope.length > 0) {
                //     this.ruleInfo.include_province_desc = this.ruleInfo.province_desc
                // } else {
                //     this.ruleInfo.include_province_desc = '设置包含省'
                // }

                // if (this.ruleInfo.exclude_province_scope !== null && this.ruleInfo.exclude_province_scope.length > 0) {
                //     this.ruleInfo.exclude_province_desc = this.ruleInfo.province_desc
                // } else {
                //     this.ruleInfo.exclude_province_desc = '设置不包含省'
                // }

                // 城市
                // 城市 - 根据后端数组初始化scope_type和scope
                if (this.ruleInfo.include_city_scope !== null && this.ruleInfo.include_city_scope.length > 0) {
                    this.ruleInfo.city_scope_type = 2 // 包含模式
                    this.ruleInfo.city_scope = this.ruleInfo.include_city_scope
                    this.ruleInfo.city_desc = '已包含' + this.ruleInfo.include_city_scope.length + '个城市'
                } else if (this.ruleInfo.exclude_city_scope !== null && this.ruleInfo.exclude_city_scope.length > 0) {
                    this.ruleInfo.city_scope_type = 3 // 排除模式
                    this.ruleInfo.city_scope = this.ruleInfo.exclude_city_scope
                    this.ruleInfo.city_desc = '已排除' + this.ruleInfo.exclude_city_scope.length + '个城市'
                } else {
                    this.ruleInfo.city_scope_type = 2 // 默认包含模式
                    this.ruleInfo.city_scope = []
                    this.ruleInfo.city_desc = '不限'
                }

                // if (this.ruleInfo.hasOwnProperty('include_hall_scope') && this.ruleInfo['include_hall_scope'] !== undefined && this.ruleInfo.include_hall_scope !== null && this.ruleInfo.include_hall_scope.length > 0) {
                //     this.ruleInfo.include_hall_desc = this.ruleInfo.include_hall_scope.join('、')
                // } else {
                //     this.ruleInfo.include_hall_desc = '设置包含影厅'
                // }

                // if (this.ruleInfo.hasOwnProperty('hall_name') && this.ruleInfo['hall_name'] !== undefined && this.ruleInfo.hall_name !== null && this.ruleInfo.hall_name.length > 0) {
                //     this.ruleInfo.exclude_hall_desc = this.ruleInfo.hall_name.join('、')
                // } else {
                //     this.ruleInfo.exclude_hall_desc = '设置不包含影厅'
                // }

                // 影院 - 根据后端数组初始化scope_type和scope
                if (this.ruleInfo.include_cinema_scope !== null && this.ruleInfo.include_cinema_scope.length > 0) {
                    this.ruleInfo.cinema_scope_type = 2 // 包含模式
                    this.ruleInfo.cinema_scope = this.ruleInfo.include_cinema_scope
                    this.ruleInfo.cinema_desc = '已包含' + this.ruleInfo.include_cinema_scope.length + '个影院'
                } else if (this.ruleInfo.exclude_cinema_scope !== null && this.ruleInfo.exclude_cinema_scope.length > 0) {
                    this.ruleInfo.cinema_scope_type = 3 // 排除模式
                    this.ruleInfo.cinema_scope = this.ruleInfo.exclude_cinema_scope
                    this.ruleInfo.cinema_desc = '已排除' + this.ruleInfo.exclude_cinema_scope.length + '个影院'
                } else {
                    this.ruleInfo.cinema_scope_type = 2 // 默认包含模式
                    this.ruleInfo.cinema_scope = []
                    this.ruleInfo.cinema_desc = '不限'
                }

                // 影院分类
                if (this.ruleInfo.class_scope_type !== undefined && this.ruleInfo.class_scope_type !== null) {
                    this.ruleInfo.class_scope_type = Number(this.ruleInfo.class_scope_type)
                    this.ruleInfo.class_scope = Array.isArray(this.ruleInfo.class_scope) ? this.ruleInfo.class_scope.map(Number) : []
                    if (this.ruleInfo.class_scope.length > 0) {
                        this.ruleInfo.class_desc = this.ruleInfo.class_scope_type === 2 ? '已包含' + this.ruleInfo.class_scope.length + '个分类' : '已排除' + this.ruleInfo.class_scope.length + '个分类'
                    } else {
                        this.ruleInfo.class_desc = '不限'
                    }
                } else {
                    this.ruleInfo.class_scope_type = 1
                    this.ruleInfo.class_scope = []
                    this.ruleInfo.class_desc = '不限'
                }

                // 影片
                // if (this.ruleInfo.include_movie_scope !== null && this.ruleInfo.include_movie_scope.length > 0) {
                //     this.ruleInfo.include_movie_desc = this.ruleInfo.movie_desc
                // } else {
                //     this.ruleInfo.include_movie_desc = '设置包含影片'
                // }

                // if (this.ruleInfo.exclude_movie_scope !== null && this.ruleInfo.exclude_movie_scope.length > 0) {
                //     this.ruleInfo.exclude_movie_desc = this.ruleInfo.movie_desc
                // } else {
                //     this.ruleInfo.exclude_movie_desc = '设置不包含影片'
                // }

                // 星期
                // if (this.ruleInfo.week_days !== null && this.ruleInfo.week_days.length > 0) {
                //     this.ruleInfo.week_desc = this.ruleInfo.week_days.join('、')
                // } else {
                //     this.ruleInfo.week_desc = '设置包含星期'
                // }

                this.ruleInfo.bid_type = parseInt(this.ruleInfo.bid_type, 10);

                if (this.ruleInfo.line_name === '-') {
                    this.ruleInfo.line_name = '不限'
                }

                // 处理新版本字段的初始化
                // 处理院线范围字段 - 支持后台返回gp_line_id数组
                if (this.ruleInfo.gp_line_id && Array.isArray(this.ruleInfo.gp_line_id)) {
                    // 后台返回gp_line_id数组，直接使用
                    this.ruleInfo.gp_line_id = [...this.ruleInfo.gp_line_id]
                } else if (!this.ruleInfo.gp_line_scope) {
                    this.ruleInfo.gp_line_id = []
                }

                // 处理座位数列表字段
                if (this.ruleInfo.ticket_num && this.ruleInfo.ticket_num.length > 0) {
                    // 如果ticket_num为空，但ticket_num有值，使用ticket_num
                    this.ruleInfo.ticket_num = [...this.ruleInfo.ticket_num]
                } else if (!this.ruleInfo.ticket_num) {
                    this.ruleInfo.ticket_num = [0]
                }

                // 处理情侣座字段
                if (this.ruleInfo.seat_tag === undefined || this.ruleInfo.seat_tag === null) {
                    this.ruleInfo.seat_tag = '1' // 默认包含情侣座
                }

                // 处理时间范围字段
                if (this.ruleInfo.time_scope && this.ruleInfo.time_scope.length >= 2) {
                    this.ruleInfo.begin_time = this.ruleInfo.time_scope[0] || ''
                    this.ruleInfo.end_time = this.ruleInfo.time_scope[1] || ''
                }

                // 处理日期范围字段
                if (this.ruleInfo.date_scope && this.ruleInfo.date_scope.length >= 2) {
                    this.ruleInfo.begin_date = this.ruleInfo.date_scope[0] || ''
                    this.ruleInfo.end_date = this.ruleInfo.date_scope[1] || ''
                }

                // 设置院线范围描述
                if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                    const scopeType = this.ruleInfo.gp_line_scope_type === 2 ? '已选择' : '已排除'
                    this.ruleInfo.gp_line_desc = `${scopeType}${this.ruleInfo.gp_line_id.length}个院线`
                } else {
                    this.ruleInfo.gp_line_desc = '请选择院线范围'
                }

                // 影厅价格
                if (this.ruleInfo.hall_value != null && this.ruleInfo.hall_value.length > 0) {
                    // 找出vip、imax价格设置
                    this.hallPriceList = this.ruleInfo.hall_value.map(el => {
                        if (el.hall_name == 'IMAX' && el.hasOwnProperty('price')) {
                            this.ruleInfo.imax_price = el.price
                        }

                        if (el.hall_name == 'VIP' && el.hasOwnProperty('price')) {
                            this.ruleInfo.vip_price = el.price
                        }
                    })
                }

                console.log(this.ruleInfo)

                if (this.copy) {
                    // 名字加上1。id置空
                    this.ruleInfo.name += "(复制)"
                    this.configId = 0
                }

            })
        },
        getProvince() {
            Api.getProvinceCityList({}).then(res => {
                this.provinceList = res.list.map(el => {
                    return {
                        label: el.name,
                        value: el.id,
                        checked: false,
                    }
                })
                this.cityList = res.list
                this.filterCityList = res.list
            })
        },
        getGpline() {
            Api.getGpLineList({}).then(res => {
                this.gpLineList = res.list.map(el => {
                    return {
                        label: el.name,
                        value: el.ID,
                        checked: false,
                    }
                })
                // 初始化filterGplineList
                this.filterGplineList = [...this.gpLineList]
            })
        },
        getCinema(data) {
            console.log(data)
            Api.getCinemaList(data).then(res => {
                this.cinemaList = res.list.map(el => {
                    return {
                        name: el.name,
                        city_name: el.city_name,
                        id: el.ID,
                        checked: false,
                    }
                })
            })
        },
        getHallList(data) {
            Api.getDefaultHallList(data).then(res => {
                this.defaultHallList = res.map(el => {
                    return {
                        name: el.name,
                    }
                })
            })
        },
        getMovieList() {
            const data = {
                'pageSize': 100,
                'page': 1,
                'orderKey': 'created_at',
                'desc': true
            }
            Api.getMovieList(data).then(res => {
                this.movieList = res.list.map(el => {
                    return {
                        name: el.name,
                        id: el.ID,
                        checked: false,
                    }
                })
            })
        },
        setStatus(checked) {
            console.log(checked)
            if (checked) {
                this.ruleInfo.status = 1;
            } else {
                this.ruleInfo.status = 2;
            }
        },
        goBack() {
            this.$router.go(-1);
        },
        deleteRule() {
            Dialog.confirm({
                    message: '确认删除报价方案？'
                })
                .then(() => {
                    Api.deleteConfig({
                        id: this.ruleInfo.id
                    }).then(res => {
                        this.goBack()
                    })
                })
                .catch(() => {
                    // on cancel
                });
        },
        showProvinceSelect(src) {
            this.selectProvince = true;
            this.src = src;
            this.selectCount = 0;
            this.selectProvinceList = []
            this.filterProvinceList = []

            let curProvinceList = [];
            if (src === 1) {
                // 选择省份，遍历省份filterProvinceList，将选择的省份checked=true
                curProvinceList = this.ruleInfo.include_province_scope
            } else {
                curProvinceList = this.ruleInfo.exclude_province_scope
            }
            console.log(curProvinceList)
            console.log(this.provinceList)
            this.provinceList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                if (curProvinceList != null && curProvinceList.indexOf(item.value) != -1) {
                    checked = true;
                    console.log('not in')
                    this.selectCount++;
                    this.selectProvinceList.push({
                        label: item.label,
                        value: item.value,
                    })
                }

                this.filterProvinceList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked,
                })
                /*
                if (this.selectProvinces.indexOf(item.value) != -1 && item.checked) {
                    item.checked = true;
                    this.selectCount++;
                } else {
                    item.checked = false;
                }
                */
            })
            console.log(this.filterProvinceList)
        },
        provinceCheck(index) {
            // console.log(this.filterProvinceList[index].checked)
            this.filterProvinceList[index].checked = !this.filterProvinceList[index].checked;
            if (this.filterProvinceList[index].checked) {
                this.selectProvinceList.push(this.filterProvinceList[index])
                this.selectCount++
            } else {
                this.selectProvinceList.forEach((item, index1) => {
                    if (item.value === this.filterProvinceList[index].value) {
                        this.selectProvinceList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetProvince() {
            this.filterProvinceList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectProvinceList = []
            this.selectCount = 0
        },
        searchProvinceClick() {
            if (this.searchText) {
                this.filterProvinceList.filter(item => {
                    return item.label.indexOf(this.searchText) != -1
                })

            }
        },
        saveProvince() {
            // let data = []
            // this.filterProvinceList.forEach(item => {
            //     // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
            //     if (item.checked) {
            //         data.push(item)
            //     }
            // })

            // 遍历data，将选择的省份名保存在include_province_desc和exclude_province_desc
            let provinceName = ''
            let provinceId = []
            this.selectProvinceList.forEach(item => {
                provinceName += item.label + ','
                provinceId.push(item.value)
            })

            if (provinceName === '') {
                if (this.src == 1) {
                    provinceName = '设置包含省'
                } else {
                    provinceName = '设置不包含省'
                }

            }
            this.ruleInfo[this.src == 1 ? 'include_province_desc' : 'exclude_province_desc'] = provinceName
            this.ruleInfo[this.src == 1 ? 'include_province_scope' : 'exclude_province_scope'] = provinceId

            this.selectProvince = false
        },
        clearProvinceClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterGplineList = []

            this.provinceList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectProvinceList.forEach(item2 => {
                    if (item2.value === item.value) {
                        checked = true;
                        return
                    }
                })

                this.filterProvinceList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked,
                })
            })
        },

        showCitySelect() {
            console.log('showCitySelect')
            this.selectCount = 0;
            this.selectCityList = []
            this.filterCityList = []

            // 使用统一的city_scope和city_scope_type
            let curCityList = [];
            
            if (this.ruleInfo.city_scope && this.ruleInfo.city_scope.length > 0) {
                curCityList = this.ruleInfo.city_scope;
                this.src = this.ruleInfo.city_scope_type; // 使用统一的scope_type
            } else {
                // 默认包含模式
                this.src = 1;
            }

            // console.log(curCityList)
            // console.log(this.cityList)
            this.cityList.forEach((item, index) => {
                let info = ''
                let arrCity = []
                item.city_list.forEach(itemCity => {
                    // item.value是否在this.ruleInfo.exclude_city_scope中，
                    // console.log(itemCity.ID, curCityList)
                    let checked = false
                    // console.log(checked)
                    if (curCityList != null) {
                        curCityList.forEach(item1 => {
                            // console.log(item1, itemCity.ID)
                            if (item1 === itemCity.city_code) {
                                checked = true;
                                this.selectCount++;
                                if (info == '') {
                                    info = 1
                                } else {
                                    info++
                                }
                                if (this.activeIndex == 0) {
                                    this.activeIndex = index
                                }
                                return
                            }
                        })
                    }

                    if (checked) {
                        this.selectCityList.push({
                            name: itemCity.name,
                            id: itemCity.ID,
                            city_code: itemCity.city_code
                        })
                    }
                    arrCity.push({
                        name: itemCity.name,
                        id: itemCity.ID,
                        city_code: itemCity.city_code,
                        checked: checked
                    })
                })

                this.filterCityList.push({
                    text: item.name,
                    info: info,
                    city_list: arrCity
                })
            })

            console.log(this.filterCityList)
            this.selectCity = true;

        },
        toggleCity(index) {

            // if (this.filterCityList[this.activeIndex].city_list[index].checked) {
            //     console.log('not in222')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = false
            // }else {
            //     console.log('not in')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = true
            // }
            // this.filterCityList[this.activeIndex].city_list[index].checked = !this.filterCityList[this.activeIndex].city_list[index].checked;
            console.log(this.filterCityList[this.activeIndex].city_list[index])
            if (this.filterCityList[this.activeIndex].city_list[index].checked) {
                this.selectCount++
                if (this.filterCityList[this.activeIndex].info == '') {
                    this.filterCityList[this.activeIndex].info = 1
                } else {
                    this.filterCityList[this.activeIndex].info++
                }

                // 添加选中的城市
                this.selectCityList.push({
                    name: this.filterCityList[this.activeIndex].city_list[index].name,
                    id: this.filterCityList[this.activeIndex].city_list[index].id,
                    city_code: this.filterCityList[this.activeIndex].city_list[index].city_code
                })

            } else {
                this.selectCount--
                this.filterCityList[this.activeIndex].info--

                // 删除已选
                for (let i = 0; i < this.selectCityList.length; i++) {
                    if (this.selectCityList[i].id == this.filterCityList[this.activeIndex].city_list[index].id) {
                        this.selectCityList.splice(i, 1)
                        break
                    }
                }
            }
        },
        resetCity() {
            this.filterCityList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.info = '';
                item.city_list.forEach(item => {
                    item.checked = false;
                })
            })
            this.selectCount = 0
            this.selectCityList = []
        },
        saveCity() {
            // 包含模式：将选中的城市保存到统一字段
            let cityName = ''
            let cityId = []
            this.selectCityList.forEach(item => {
                cityName += item.name + ','
                cityId.push(item.city_code)
            })
            if (cityName === '') {
                cityName = '设置包含城市'
            } else {
                cityName = '已包含' + this.selectCityList.length + '个城市'
            }
            
            // 设置统一字段
            this.ruleInfo.city_desc = cityName
            this.ruleInfo.city_scope = cityId
            this.ruleInfo.city_scope_type = 2 // 包含模式

            this.selectCity = false
        },
        saveCityExclude() {
            // 排除模式：将选中的城市保存到统一字段
            let cityName = ''
            let cityId = []
            this.selectCityList.forEach(item => {
                cityName += item.name + ','
                cityId.push(item.city_code)
            })
            if (cityName === '') {
                cityName = '设置不包含城市'
            } else {
                cityName = '已排除' + this.selectCityList.length + '个城市'
            }
            
            // 设置统一字段
            this.ruleInfo.city_desc = cityName
            this.ruleInfo.city_scope = cityId
            this.ruleInfo.city_scope_type = 3 // 排除模式

            this.selectCity = false
        },
        clearCityClick() {
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterCityList = []
            this.activeIndex == 0
            this.selectCount = 0

            this.cityList.forEach((item, index) => {
                let info = ''
                let arrCity = []
                item.city_list.forEach(itemCity => {
                    // item.value是否在this.ruleInfo.exclude_city_scope中，
                    console.log(itemCity.ID, this.selectCityList)
                    let checked = false
                    console.log(checked)
                    this.selectCityList.forEach(item1 => {
                        console.log(item1, itemCity.ID)
                        if (item1.id === itemCity.ID) {
                            checked = true;
                            this.selectCount++;
                            if (info == '') {
                                info = 1
                            } else {
                                info++
                            }
                            if (this.activeIndex == 0) {
                                this.activeIndex = index
                            }
                            return
                        }
                    })

                    arrCity.push({
                        name: itemCity.name,
                        id: itemCity.ID,
                        checked: checked,
                        city_code: itemCity.city_code
                    })
                })

                this.filterCityList.push({
                    text: item.name,
                    info: info,
                    city_list: arrCity
                })
            })
        },
        searchCityClick() {
            console.log(this.searchText)
            if (this.searchText) {
                // this.selectCity = false
                this.filterCityList = []
                this.activeIndex == 0

                this.cityList.forEach((item, index) => {
                    let info = ''
                    let arrCity = []
                    let checked = false
                    item.city_list.forEach(itemCity => {
                        // item.value是否在this.ruleInfo.exclude_city_scope中，
                        // console.log(this.searchText, itemCity.name)

                        // console.log(checked)
                        if (itemCity.name.indexOf(this.searchText) !== -1) {
                            checked = true;
                            if (info == '') {
                                info = 1
                            } else {
                                info++
                            }
                            if (this.activeIndex == 0) {
                                this.activeIndex = index
                            }
                        }

                        // if (checked) {
                        arrCity.push({
                            name: itemCity.name,
                            id: itemCity.ID,
                            checked: false,
                            city_code: itemCity.city_code
                        })
                        // }

                    })
                    // console.log(arrCity)
                    // if (arrCity.length > 0) {
                    this.filterCityList.push({
                        text: item.name,
                        // info: info,
                        city_list: arrCity,
                        dot: checked ? true : false

                    })
                    // }
                    // return

                })
                this.filterCityList.sort((a, b) => b.dot - a.dot)
                this.activeIndex = 0
                // console.log(this.filterCityList)
                // this.selectCity = true
            }
        },

        showGplineSelect(isSingle = false) {
            this.src = isSingle ? 1 : 2
            this.selectGpline = true
            this.searchText = ''
            this.selectCount = 0

            // 重置选择状态
            this.filterGplineList.forEach(item => {
                item.checked = false
            })

            // 如果是单选模式，设置已选择的院线
            if (isSingle && this.ruleInfo.gp_line > 0) {
                this.filterGplineList.forEach(item => {
                    if (item.value === this.ruleInfo.gp_line) {
                        item.checked = true
                        this.selectCount = 1
                    }
                })
            } else if (!isSingle && this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                // 多选模式，设置已选择的院线
                this.gpLineScopeType = this.ruleInfo.gp_line_scope_type
                this.filterGplineList.forEach(item => {
                    if (this.ruleInfo.gp_line_id.includes(item.value)) {
                        item.checked = true
                        this.selectCount++
                    }
                })
            }
        },
        gplineCheck(index) {
            this.filterGplineList[index].checked = !this.filterGplineList[index].checked;
            if (this.filterGplineList[index].checked) {
                this.selectCount++
            } else {
                this.selectCount--
            }
        },
        searchGplineClick() {
            if (this.searchText) {
                this.filterGplineList = []

                this.gpLineList.forEach(item => {
                    if (item.label.indexOf(this.searchText) !== -1) {
                        let checked = false
                        if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.includes(item.value)) {
                            checked = true;
                        }
                        this.filterGplineList.push({
                            label: item.label,
                            value: item.value,
                            checked: checked
                        })
                    }
                })
                console.log(this.filterGplineList)
            }
        },
        clearGplineClick() {
            this.searchText = '';
            this.filterGplineList = []

            this.gpLineList.forEach(item => {
                let checked = false
                if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.includes(item.value)) {
                    checked = true;
                }
                this.filterGplineList.push({
                    label: item.label,
                    value: item.value,
                    checked: checked
                })
            })
        },
        resetGpline() {
            this.filterGplineList.forEach(item => {
                item.checked = false;
            })
            this.selectCount = 0
        },
        saveGpline() {
            if (this.src === 1) {
                // 单选模式（兼容老版本）
                this.ruleInfo.gp_line = this.selectedGpline;
                this.ruleInfo.line_name = this.filterGplineList[this.selectedGpline].label;
            } else {
                // 多选模式（新版本）
                let selectedGplines = []
                let selectedNames = []

                this.filterGplineList.forEach(item => {
                    if (item.checked) {
                        selectedGplines.push(item.value)
                        selectedNames.push(item.label)
                    }
                })

                this.ruleInfo.gp_line_id = selectedGplines
                this.ruleInfo.gp_line_scope_type = 2 // 设置为包含类型

                if (selectedNames.length > 0) {
                    this.ruleInfo.gp_line_desc = `已选择${selectedNames.length}个院线`
                } else {
                    this.ruleInfo.gp_line_desc = '请选择院线范围'
                }
            }
            // 强制刷新（如有响应式问题）
            this.$forceUpdate && this.$forceUpdate();
            this.selectGpline = false;
        },

        saveGplineExclude() {
            if (this.src === 1) {
                // 单选模式（兼容老版本）
                this.ruleInfo.gp_line = this.selectedGpline;
                this.ruleInfo.line_name = this.filterGplineList[this.selectedGpline].label;
            } else {
                // 多选模式（新版本）
                let selectedGplines = []
                let selectedNames = []

                this.filterGplineList.forEach(item => {
                    if (item.checked) {
                        selectedGplines.push(item.value)
                        selectedNames.push(item.label)
                    }
                })

                this.ruleInfo.gp_line_id = selectedGplines
                this.ruleInfo.gp_line_scope_type = 3 // 设置为排除类型

                if (selectedNames.length > 0) {
                    this.ruleInfo.gp_line_desc = `已排除${selectedNames.length}个院线`
                } else {
                    this.ruleInfo.gp_line_desc = '请选择院线范围'
                }
            }
            // 强制刷新（如有响应式问题）
            this.$forceUpdate && this.$forceUpdate();
            this.selectGpline = false;
        },

        // 获取院线显示颜色
        getGplineColor() {
            if (!this.ruleInfo.gp_line_scope || this.ruleInfo.gp_line_scope.length === 0) {
                return 'inherit'; // 继承默认颜色，不改变标题颜色
            }
            return this.ruleInfo.gp_line_scope_type === 3 ? '#ff2c54' : '#07c160'; // 排除红色，选择绿色
        },

        // 获取院线显示颜色类名
        getGplineColorClass() {
            if (!this.ruleInfo.gp_line_id || this.ruleInfo.gp_line_id.length === 0) {
                return ''; // 无特殊颜色
            }
            return this.ruleInfo.gp_line_scope_type === 3 ? 'gpline-exclude' : 'gpline-include'; // 排除红色，选择绿色
        },

        // 获取城市显示颜色类名
        getCityColorClass() {
            // 根据最终选择结果决定颜色
            const hasCity = this.ruleInfo.city_scope && this.ruleInfo.city_scope.length > 0;
            
            if (hasCity) {
                // 根据city_scope_type判断是包含还是排除
                if (this.ruleInfo.city_scope_type === 3) {
                    return 'city-exclude'; // 排除红色
                } else {
                    return 'city-include'; // 包含绿色
                }
            }
            return ''; // 无特殊颜色
        },

        // 获取影院显示颜色类名
        getCinemaColorClass() {
            // 根据最终选择结果决定颜色
            const hasCinema = this.ruleInfo.cinema_scope && this.ruleInfo.cinema_scope.length > 0;
            
            if (hasCinema) {
                // 根据cinema_scope_type判断是包含还是排除
                if (this.ruleInfo.cinema_scope_type === 3) {
                    return 'cinema-exclude'; // 排除红色
                } else {
                    return 'cinema-include'; // 包含绿色
                }
            }
            return ''; // 无特殊颜色
        },

        getClassColorClass() {
            const hasClass = this.ruleInfo.class_scope && this.ruleInfo.class_scope.length > 0
            if (!hasClass) return ''
            return this.ruleInfo.class_scope_type === 3 ? 'class-exclude' : 'class-include'
        },

        showClassSelect() {
            this.selectClass = true
            this.classScopeType = (this.ruleInfo.class_scope_type === 3) ? 3 : 2
            this.classListLoading = true
            Api.getCinemaClassSelectList()
                .then(res => {
                    const list = (res && res.list) || (res && res.data && res.data.list) || []
                    const arr = Array.isArray(list) ? list : []
                    const curIds = new Set((this.ruleInfo.class_scope || []).map(Number))
                    this.filterClassList = arr.map(item => ({
                        id: item.id,
                        name: item.name || item.label,
                        checked: curIds.has(Number(item.id))
                    }))
                    this.selectClassList = this.filterClassList.filter(c => c.checked).map(c => c.id)
                })
                .catch(() => {
                    this.$toast.fail('加载可选分类失败')
                    this.filterClassList = []
                    this.selectClassList = []
                })
                .finally(() => {
                    this.classListLoading = false
                })
        },
        toggleClassCheck(index) {
            const item = this.filterClassList[index]
            if (!item) return
            item.checked = !item.checked
            this.selectClassList = this.filterClassList.filter(c => c.checked).map(c => c.id)
        },
        resetClass() {
            this.filterClassList.forEach(c => { c.checked = false })
            this.selectClassList = []
        },
        saveClassAsInclude() {
            this.classScopeType = 2
            this.saveClass()
        },
        saveClassAsExclude() {
            this.classScopeType = 3
            this.saveClass()
        },
        saveClass() {
            const ids = this.filterClassList.filter(c => c.checked).map(c => Number(c.id))
            this.ruleInfo.class_scope_type = this.classScopeType
            this.ruleInfo.class_scope = ids
            if (ids.length > 0) {
                this.ruleInfo.class_desc = this.classScopeType === 2 ? '已包含' + ids.length + '个分类' : '已排除' + ids.length + '个分类'
            } else {
                this.ruleInfo.class_desc = '不限'
                this.ruleInfo.class_scope_type = 1
            }
            this.selectClass = false
        },

        showCinemaSelect() {
            console.log('showCinemaSelect')
            this.selectCount = 0;
            this.selectCinemaCount = 0;
            this.selectedGpline = 0;
            this.searchCinemaText = '';
            this.selectCinemaList = this.ruleInfo.select_cinema;
            this.filterCinemaList = []

            // 使用统一的cinema_scope和cinema_scope_type
            let curCinemaList = [];
            
            if (this.ruleInfo.cinema_scope && this.ruleInfo.cinema_scope.length > 0) {
                curCinemaList = this.ruleInfo.cinema_scope;
                this.src = this.ruleInfo.cinema_scope_type; // 使用统一的scope_type
            } else {
                // 默认包含模式
                this.src = 1;
            }

            if (curCinemaList != null) {
                this.selectCinemaCount = curCinemaList.length
            }
            // this.selectCinemaCount = curCinemaList.length
            // this.selectCinemaList = curCinemaList
            // if (this.ruleInfo.cinema_desc != '') {
            //     // 分割,
            //     this.selectCinemaNameList = this.ruleInfo.cinema_desc.split(',')
            // }
            // this.selectCinemaCount = this.selectCinemaNameList.length

            // 处理列表中的影院
            this.cinemaList.forEach(item => {
                let checked = false
                if (curCinemaList != null && curCinemaList.indexOf(item.id) != -1) {
                    checked = true;
                }

                // if (checked) {
                //     this.selectCinemaCount++
                //     this.selectCinemaList.push({
                //         name: item.name,
                //         city_name: item.city_name,
                //         id: item.id,
                //     })
                // }
                this.filterCinemaList.push({
                    name: item.name,
                    city_name: item.city_name,
                    id: item.id,
                    checked: checked,
                })
            })
            // this.showCitySelect()
            // this.showGplineSelect(false)

            // 判断filterCinemaList中是否有selectCinemaList的影院，如果有checked设置true
            if (this.selectCinemaList != null) {
                this.selectCinemaList.forEach(item => {
                    let checked = false
                    this.filterCinemaList.forEach(item2 => {
                        if (item.id === item2.id) {
                            checked = true;
                            // this.selectCinemaCount++
                        }
                    })
                    if (!checked) {
                        // 添加到filterCinemaList的第一个位置
                        this.filterCinemaList.unshift({
                            name: item.name,
                            city_name: item.city_name,
                            id: item.id,
                            checked: true,
                        })
                    }

                })
            }

            this.selectCinema = true;
        },
        resetFilterCity() {
            // 筛选城市，保存
            this.resetCity()
            this.selectCinemaCityCount = this.selectCount;
        },
        saveFiterCity() {
            console.log('saveFiterCity')
            this.selectCinemaCityCount = this.selectCount;
            this.$refs.selectCinemafilterCity.toggle(false)
            // 保存筛选的城市，并重新查询影院列表
            this.getCinemaByFitler(true)
            this.loading = false

        },
        selectCinemaFilterGplineCheck(index) {

            console.log(this.filterGplineList[index])
            this.filterGplineList[index].checked = true
            this.selectCinemaFilterGplineCount = 1
            this.$refs.selectCinemafilterGpline.toggle(false)
            this.selectCity = false
            this.selectGpline = false;
            this.selectedGpline = this.filterGplineList[index].value;
            // 保存筛选品牌，并重新查询影院列表
            // this.ruleInfo.gp_line = this.filterGplineList[index].value;
            // this.ruleInfo.line_name = this.filterGplineList[index].label;
            this.getCinemaByFitler(true)
            this.loading = false
        },
        // filterGplineCheck(index) {
        //     this.selectedGpline = this.filterGplineList[index].value;

        //     this.selectGpline = false;
        // },
        resetFilterGpline() {
            this.selectedGpline = 0;
            this.selectCinemaFilterGplineCount = 0;
            this.filterGplineList.forEach(item => {
                item.checked = false
            })
            this.$refs.selectCinemafilterGpline.toggle(false)
            this.selectGpline = false;
            this.getCinemaByFitler(true)
        },
        clearCinemaClick() {
            // 清除搜索
            this.searchCinemaText = ''
            this.getCinemaByFitler(true)
        },
        searchCinemaClick() {
            this.getCinemaByFitler(true)
        },
        getCinemaByFitler(refresh) {
            let cityId = ''
            this.selectCityList.forEach(item => {
                // cityName += item.name + ','
                if (cityId !== '') {
                    cityId += ','
                }
                cityId += item.city_code
            })
            if (refresh) {
                this.page = 1
            } else {
                this.page++
            }
            let data = {
                page: this.page,
                pageSize: this.pageSize,
                // city_codes: cityId,
                line_id: this.selectedGpline,
                name: this.searchCinemaText
            }

            if (cityId.length > 0) {
                data.city_codes = cityId
            }

            Api.getCinemaList(data).then(res => {
                this.filterCinemaList = []

                let list = res.list.map(el => {
                    return {
                        name: el.name,
                        city_name: el.city_name,
                        id: el.ID,
                        checked: false,
                    }
                })

                if (refresh) {
                    this.cinemaList = list
                } else {
                    this.cinemaList = this.cinemaList.concat(list)
                }

                if (this.cinemaList.length >= res.total) {
                    this.finished = true
                }

                // 处理列表中的影院
                this.cinemaList.forEach(item => {
                    let checked = false
                    if (this.selectCinemaList != null) {
                        this.selectCinemaList.forEach(item2 => {
                            if (item2.id == item.id) {
                                checked = true;
                                return
                            }
                        })
                    }

                    this.filterCinemaList.push({
                        name: item.name,
                        city_name: item.city_name,
                        id: item.id,
                        checked: checked,
                    })
                })

                // 判断filterCinemaList中是否有selectCinemaList的影院，如果有checked设置true
                if (this.selectCinemaList != null) {
                    this.selectCinemaList.forEach(item => {
                        let checked = false
                        this.filterCinemaList.forEach(item2 => {
                            if (item.id === item2.id) {
                                checked = true;
                                // this.selectCinemaCount++
                            }
                        })
                        if (!checked) {
                            // 添加到filterCinemaList的第一个位置
                            this.filterCinemaList.unshift({
                                name: item.name,
                                city_name: item.city_name,
                                id: item.id,
                                checked: true,
                            })
                        }

                    })
                }

            })
        },
        onLoad() {
            console.log('onLoad')
            this.getCinemaByFitler(false)
            this.loading = false
        },
        toggleCinema(index) {
            // 勾选影院
            if (this.selectCinemaList == null) {
                this.selectCinemaList = []
            }
            console.log(this.selectCinemaList)
            // if (this.filterCityList[this.activeIndex].city_list[index].checked) {
            //     console.log('not in222')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = false
            // }else {
            //     console.log('not in')
            //     this.filterCityList[this.activeIndex].city_list[index].checked = true
            // }
            // this.filterCityList[this.activeIndex].city_list[index].checked = !this.filterCityList[this.activeIndex].city_list[index].checked;
            console.log(this.filterCinemaList[index])
            if (this.filterCinemaList[index].checked) {
                // this.selectCinemaCount++

                // 添加选中的城市
                this.selectCinemaList.push({
                    name: this.filterCinemaList[index].name,
                    id: this.filterCinemaList[index].id,
                    city_name: this.filterCinemaList[index].city_name,
                })

            } else {
                // this.selectCount--

                // 删除已选
                for (let i = 0; i < this.selectCinemaList.length; i++) {
                    if (this.selectCinemaList[i].id == this.filterCinemaList[index].id) {
                        this.selectCinemaList.splice(i, 1)
                        break
                    }
                }
            }
            console.log(this.selectCinemaList)
            this.selectCinemaCount = this.selectCinemaList.length
        },
        resetCinema() {
            this.filterCinemaList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.searchCinemaText = ''
            this.selectCinemaCount = 0
            this.selectCinemaList = []
        },
        saveCinema() {
            // 包含模式：将选中的影院保存到统一字段
            let cityName = ''
            let cityId = []
            this.selectCinemaList.forEach(item => {
                cityId.push(item.id)
            })
            if (this.selectCinemaCount === 0) {
                cityName = '设置包含影院'
            } else {
                cityName = '已包含' + this.selectCinemaCount + '个影院'
            }
            
            // 设置统一字段
            this.ruleInfo.cinema_desc = cityName
            this.ruleInfo.cinema_scope = cityId
            this.ruleInfo.cinema_scope_type = 2 // 包含模式

            this.ruleInfo.select_cinema = this.selectCinemaList
            console.log(this.ruleInfo)
            this.selectCinema = false
        },
        saveCinemaExclude() {
            // 排除模式：将选中的影院保存到统一字段
            let cityName = ''
            let cityId = []
            this.selectCinemaList.forEach(item => {
                cityId.push(item.id)
            })
            if (this.selectCinemaCount === 0) {
                cityName = '设置不包含影院'
            } else {
                cityName = '已排除' + this.selectCinemaCount + '个影院'
            }
            
            // 设置统一字段
            this.ruleInfo.cinema_desc = cityName
            this.ruleInfo.cinema_scope = cityId
            this.ruleInfo.cinema_scope_type = 3 // 排除模式
            this.ruleInfo.select_cinema = this.selectCinemaList
            console.log(this.ruleInfo)
            this.selectCinema = false
        },
        onCinemaClick() {
            console.log('11111')
            console.log(this.selectCinemaList)

            if (this.selectCinemaList.length > 0) {
                this.showSelectCinema = true
            }
        },

        // 影厅设置
        showHallSelect(src) {
            this.selectHall = true;
            this.src = src;
            this.selectCount = 0;
            this.selectHallList = []
            this.filterHallList = []

            let curHallList = [];
            if (src === 1) {
                curHallList = this.ruleInfo.include_hall_scope
            } else {
                curHallList = this.ruleInfo.exclude_hall_scope
            }
            console.log(this.defaultHallList)
            this.defaultHallList.forEach(item => {
                let checked = false
                if (curHallList != null && curHallList.indexOf(item.name) != -1) {
                    checked = true;
                    this.selectCount++;
                    this.selectHallList.push(item.name)
                }

                this.filterHallList.push({
                    label: item.name,
                    value: item.name,
                    checked: checked,
                })
            })
        },
        hallCheck(index) {
            this.filterHallList[index].checked = !this.filterHallList[index].checked;
            if (this.filterHallList[index].checked) {
                this.selectHallList.push(this.filterHallList[index].value)
                this.selectCount++
            } else {
                this.selectHallList.forEach((item, index) => {
                    if (item === this.filterHallList[index].value) {
                        this.selectHallList.splice(index, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetHall() {
            this.filterHallList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectHallList = []
            this.selectCount = 0
        },
        searchHallClick() {

            this.filterHallList = []
            this.defaultHallList.forEach(item => {

                if (item.name.indexOf(this.searchText) != -1) {
                    let checked = false
                    this.selectHallList.forEach(item1 => {
                        if (item1.name === item.name) {
                            checked = true
                            return
                        }
                    })
                    this.filterHallList.push({
                        label: item.name,
                        value: item.name,
                        checked: checked,
                    })
                }

            })
        },
        saveHall() {
            let hallName = ''
            this.selectHallList.forEach(item => {
                hallName += item + ','
            })

            if (hallName === '') {
                if (this.src == 1) {
                    hallName = '设置包含影厅'
                } else {
                    hallName = '设置不包含影厅'
                }

            }
            this.ruleInfo[this.src == 1 ? 'include_hall_desc' : 'exclude_hall_desc'] = hallName
            this.ruleInfo[this.src == 1 ? 'include_hall_scope' : 'exclude_hall_scope'] = this.selectHallList

            this.selectHall = false
            console.log(this.ruleInfo)
        },
        clearHallClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterHallList = []

            this.defaultHallList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectHallList.forEach(item2 => {
                    if (item2 === item.value) {
                        checked = true;
                        return
                    }
                })

                this.filterHallList.push({
                    label: item.name,
                    value: item.name,
                    checked: checked,
                })
            })
        },

        // 影片设置
        showMovieSelect(src) {
            this.selectMovie = true;
            this.src = src;
            this.selectCount = 0;
            this.selectMovieList = []
            this.filterMovieList = []

            let curMovieList = [];
            if (src === 1) {
                curMovieList = this.ruleInfo.include_movie_scope
            } else {
                curMovieList = this.ruleInfo.exclude_movie_scope
            }
            this.movieList.forEach(item => {
                let checked = false
                if (curMovieList != null && curMovieList.indexOf(item.id) != -1) {
                    checked = true;
                    this.selectCount++;
                    this.selectMovieList.push({
                        name: item.name,
                        id: item.id
                    })
                }

                this.filterMovieList.push({
                    label: item.name,
                    value: item.id,
                    checked: checked,
                })
            })
        },
        movieCheck(index) {
            this.filterMovieList[index].checked = !this.filterMovieList[index].checked;
            if (this.filterMovieList[index].checked) {
                this.selectMovieList.push({
                    name: this.filterMovieList[index].label,
                    id: this.filterMovieList[index].value
                })
                this.selectCount++
            } else {
                this.selectMovieList.forEach((item, index1) => {
                    if (item === this.filterMovieList[index].value) {
                        this.selectMovieList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetMovie() {
            this.filterMovieList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectMovieList = []
            this.selectCount = 0
        },
        searchMovieClick() {

            this.filterMovieList = []
            this.movieList.forEach(item => {

                if (item.name.indexOf(this.searchText) != -1) {
                    let checked = false
                    this.selectMovieList.forEach(item1 => {
                        if (item1.id === item.id) {
                            checked = true
                            return
                        }
                    })
                    this.filterMovieList.push({
                        label: item.name,
                        value: item.id,
                        checked: checked,
                    })
                }

            })
        },
        saveMovie() {
            let name = ''
            let ids = []
            this.selectMovieList.forEach(item => {
                name += item.name + ','
                ids.push(item.id)
            })

            if (name === '') {
                if (this.src == 1) {
                    name = '设置包含影片'
                } else {
                    name = '设置不包含影片'
                }

            }
            this.ruleInfo[this.src == 1 ? 'include_movie_desc' : 'exclude_movie_desc'] = name
            this.ruleInfo[this.src == 1 ? 'include_movie_scope' : 'exclude_movie_scope'] = ids

            this.selectMovie = false
            console.log(this.ruleInfo)
        },
        clearMovieClick() {
            // 清除省份搜索
            this.searchText = '';
            // this.filterGplineList = this.gplineList;
            this.filterMovieList = []

            this.movieList.forEach(item => {
                // item.value是否在this.ruleInfo.include_province_scope中，
                let checked = false
                // 判断是否在选中省份中

                this.selectMovieList.forEach(item2 => {
                    if (item2.id === item.id) {
                        checked = true;
                        return
                    }
                })

                this.filterMovieList.push({
                    label: item.name,
                    value: item.id,
                    checked: checked,
                })
            })
        },

        // 时间
        changeTime(from) {
            console.log(from)
            this.selectTime = true;
            this.src = from;
            if (from == 1) {
                this.currentTime = this.ruleInfo.begin_time;
            } else {
                this.currentTime = this.ruleInfo.end_time;
            }
        },
        timeCheck(value) {
            console.log(value);
            if (this.src == 1) {
                this.ruleInfo.begin_time = value;
            } else {
                this.ruleInfo.end_time = value;
            }
            this.selectTime = false;
        },

        // 星期设置
        showWeekSelect() {
            this.selectWeek = true;
            this.selectCount = 0;
            this.selectWeekList = []
            this.filterWeekList = []

            let curWeekList = this.ruleInfo.week_days;

            this.weekList.forEach(item => {
                let checked = false
                if (curWeekList != null) {
                    curWeekList.forEach(item1 => {
                        if (item1 === item.label) {
                            checked = true
                            return
                        }
                    })
                }

                if (checked) {
                    this.selectCount++;
                    this.selectWeekList.push({
                        name: item.label,
                        id: item.id
                    })
                }

                this.filterWeekList.push({
                    name: item.label,
                    value: item.id,
                    checked: checked,
                })
            })
            console.log(this.filterWeekList)
        },
        weekCheck(index) {
            this.filterWeekList[index].checked = !this.filterWeekList[index].checked;
            if (this.filterWeekList[index].checked) {
                this.selectWeekList.push({
                    name: this.filterWeekList[index].name,
                    id: this.filterWeekList[index].value
                })
                this.selectCount++
            } else {
                this.selectWeekList.forEach((item, index1) => {
                    if (item.name === this.filterWeekList[index].name) {
                        this.selectWeekList.splice(index1, 1)
                    }
                })
                this.selectCount--
            }

        },
        resetWeek() {
            this.filterWeekList.forEach(item => {
                // item.value是否在this.selectProvinces中，如果在且选中，则设置checked=true
                item.checked = false;
            })
            this.selectWeekList = []
            this.selectCount = 0
        },

        saveWeek() {
            let name = ''
            let weeks = []
            this.selectWeekList.forEach(item => {
                name += item.name + '、'
                weeks.push(item.name)
            })

            if (name === '') {
                name = '设置包含星期'
            }
            this.ruleInfo['week_days'] = weeks
            this.ruleInfo.week_desc = name

            this.selectWeek = false
        },
        showSpecialPrice() {
            this.specialPrice = true

            if (this.filterHallList.length === 0) {
                this.selectHallList = []
                this.filterHallList = []

                let curHallList = this.ruleInfo.hall_value;

                if (curHallList != null && curHallList.length > 0) {
                    this.ruleInfo.hall_value.forEach(item => {
                        if (item.hall_name === 'IMAX' || item.hall_name === 'VIP') {
                            return
                        }

                        console.log(item)
                        let value = ''
                        let is_user = false
                        // if (curHallList != null) {
                        //     curHallList.forEach(item1 => {
                        //         if (item1.hall_name === item.name) {
                        //             if (item1.hasOwnProperty('value') && item1.value != null) {
                        //                 value = item1.value
                        //             }
                        //             is_user = item1.is_user
                        //             return
                        //         }
                        //     })
                        // }

                        if (item.hasOwnProperty('price') && item.price > 0) {
                            value = item.price
                        }
                        if (item.hasOwnProperty('is_user') && item.is_user != null) {
                            is_user = item.is_user
                        }
                        this.filterHallList.push({
                            hall_name: item.hall_name,
                            price: value,
                            is_user: is_user,
                        })

                    })

                    // filterHallList排序，is_user=true排再前面
                    this.filterHallList.sort((a, b) => {
                        // 如果 a.is_user 是 true，那么它应该排在 b 前面
                        if (a.is_user && !b.is_user) {
                            return -1;
                        }
                        // 如果 b.is_user 是 true，那么它应该排在 a 前面
                        if (!a.is_user && b.is_user) {
                            return 1;
                        }
                        // 如果 a 和 b 的 is_user 值相同，那么它们的位置不变
                        return 0;
                    });
                } else {
                    this.defaultHallList.forEach(item => {
                        if (item.hall_name === 'IMAX' || item.name === 'VIP') {
                            return
                        }

                        this.filterHallList.push({
                            hall_name: item.name,
                            price: '',
                            is_user: false,
                        })
                    })
                }

            }

        },
        showHall() {
            this.custom_hall_name = ''
            this.showHallSet = true
        },
        addHall() {
            // 在fiterHallList的头部一项
            this.filterHallList.unshift({
                hall_name: this.custom_hall_name,
                price: '',
                is_user: true,
            })
        },
        deleteHall(index) {
            this.filterHallList.splice(index, 1)
        },
        // 处理票数选择变化
        handleTicketCountChange(value) {
            if (!this.inited) {
                this.inited = true;
                return;
            }
            if (this.lastChecked === 0) {
                if (!(value.length === 1 && value[0] === 0)) {
                    this.ruleInfo.ticket_num = [0];
                }
                return;
            }
            if (this.lastChecked !== 0 && value.includes(0)) {
                const filtered = value.filter(v => v !== 0);
                if (filtered.length !== this.ruleInfo.ticket_num.length ||
                    filtered.some((v, i) => v !== this.ruleInfo.ticket_num[i])) {
                    this.ruleInfo.ticket_num = filtered;
                }
                return;
            }
            if (value.length === 0) {
                if (!(this.ruleInfo.ticket_num.length === 1 && this.ruleInfo.ticket_num[0] === 0)) {
                    this.ruleInfo.ticket_num = [0];
                }
                return;
            }
            if (value.length !== this.ruleInfo.ticket_num.length ||
                value.some((v, i) => v !== this.ruleInfo.ticket_num[i])) {
                this.ruleInfo.ticket_num = value;
            }
        },
        lastClick(val) {
            this.lastChecked = val;
        },
        // 保存配置
        saveConfig() {
            console.log('ruleInfo:', this.ruleInfo)
            console.log('configId:', this.configId)
            console.log('filterHallList:', this.filterHallList)
            
            // 添加数据验证
            if (!this.ruleInfo.name || this.ruleInfo.name.trim() === '') {
                this.$notify({
                    type: 'warning',
                    message: '请输入规则名称'
                });
                return;
            }
            
            // 防止重复提交
            if (this.isSaving) {
                return;
            }
            this.isSaving = true;
            
            try {
                console.log('开始保存配置...');
            console.log('数据验证通过');

            console.log(this.filterHallList)
            const data = {
                'name': this.ruleInfo.name,

                'hall_scope_type': 1,
                // 'hall_name': this.addConfigDialogForm.hall_name,
                'movie_scope_type': 1,
                'province_scope_type': 1,
                'city_scope_type': 1,
                'cinema_scope_type': 1,
                'gp_line_scope_type': 1,
                // 'begin_price': this.addConfigDialogForm.begin_price,
                // 'end_price': this.addConfigDialogForm.end_price,
                // 'begin_ticket': this.addConfigDialogForm.begin_ticket,
                // 'end_ticket': this.addConfigDialogForm.end_ticket,
                'date_scope': this.ruleInfo.date_scope,
                'time_scope': [],
                'week_days': this.ruleInfo.week_days,
                'bid_type': 2,
                'hall_value': [],
                'status': this.ruleInfo.status,
            }
            console.log('基础数据对象:', data)
            data.time_scope.push(this.ruleInfo.begin_time)
            data.time_scope.push(this.ruleInfo.end_time)
            console.log('时间范围设置完成');

            console.log("this.filterHallList", this.filterHallList)
            
            // 创建临时的影厅列表，避免修改原始数据
            let tempHallList = [...this.filterHallList];
            
            // 影厅报价
            if (this.ruleInfo.normal_price != '') {
                tempHallList.push({
                    'hall_name': 'normal_hall',
                    'price': this.ruleInfo.normal_price,
                    'is_user': false,
                })
            }

            if (this.ruleInfo.imax_price != '') {
                tempHallList.push({
                    'hall_name': 'IMAX',
                    'price': this.ruleInfo.imax_price,
                    'is_user': false,
                })
            }

            if (this.ruleInfo.vip_price != '') {
                tempHallList.push({
                    'hall_name': 'VIP',
                    'price': this.ruleInfo.vip_price,
                    'is_user': false,
                })
            }
            console.log("tempHallList", tempHallList)
            
            // 处理影厅数据
            for (let i = 0; i < tempHallList.length; i++) {
                console.log(tempHallList[i])
                if (tempHallList[i].price !== undefined && tempHallList[i].price > 0) {
                    data.hall_value.push(tempHallList[i])
                }
                console.log(data.hall_value)
            }
            console.log(data)
            // 处理院线相关字段
            if (this.ruleInfo.gp_line !== 0 && this.ruleInfo.gp_line !== '') {
                data.gp_line = this.ruleInfo.gp_line
            }

            // 处理新版本的院线多选
            if (this.ruleInfo.gp_line_id && this.ruleInfo.gp_line_id.length > 0) {
                data.gp_line_scope_type = this.ruleInfo.gp_line_scope_type
                data.gp_line_scope = JSON.stringify(this.ruleInfo.gp_line_id)
            }

            if (this.ruleInfo.begin_price !== '' && this.ruleInfo.begin_price > 0) {
                data.begin_price = this.ruleInfo.begin_price
            }

            if (this.ruleInfo.end_price !== '' && this.ruleInfo.end_price > 0) {
                data.end_price = this.ruleInfo.end_price
            }

            // 处理座位数：优先使用新版本的座位数列表
            if (this.ruleInfo.ticket_num && this.ruleInfo.ticket_num.length > 0) {
                // 创建副本进行排序，避免修改原始数据
                let sortedTicketNum = [...this.ruleInfo.ticket_num].sort(function (a, b) {
                    return a - b
                })

                // 使用新版本的座位数列表字段
                data.ticket_count_list = JSON.stringify(sortedTicketNum)
                console.log('ticket_count_list:', data.ticket_count_list)
            }

            // 处理情侣座规则
            if (this.ruleInfo.seat_tag !== undefined && this.ruleInfo.seat_tag !== null) {
                data.seat_tag = this.ruleInfo.seat_tag
                console.log('seat_tag:', data.seat_tag)
            }

            console.log(this.ruleInfo.include_movie_scope)
            // 电影
            if (this.ruleInfo.include_movie_scope !== null && this.ruleInfo.include_movie_scope.length > 0) {
                data.movie_scope_type = 2
                data.movie_id = this.ruleInfo.include_movie_scope
            } else if (this.ruleInfo.exclude_movie_scope !== null && this.ruleInfo.exclude_movie_scope.length > 0) {
                data.movie_scope_type = 3
                data.movie_id = this.ruleInfo.exclude_movie_scope
            }
            console.log(this.ruleInfo.include_province_scope)
            // 省份
            if (this.ruleInfo.include_province_scope !== null && this.ruleInfo.include_province_scope.length > 0) {
                data.province_scope_type = 2
                data.province_id = this.ruleInfo.include_province_scope
            } else if (this.ruleInfo.exclude_province_scope !== null && this.ruleInfo.exclude_province_scope.length > 0) {
                data.province_scope_type = 3
                data.province_id = this.ruleInfo.exclude_province_scope
            }

            console.log(this.ruleInfo.city_scope)
            // 城市
            if (this.ruleInfo.city_scope !== undefined && this.ruleInfo.city_scope.length > 0) {
                data.city_scope_type = this.ruleInfo.city_scope_type
                data.city_id = this.ruleInfo.city_scope
            }

            console.log(this.ruleInfo.cinema_scope)
            // 影院
            if (this.ruleInfo.cinema_scope !== undefined && this.ruleInfo.cinema_scope.length > 0) {
                data.cinema_scope_type = this.ruleInfo.cinema_scope_type
                data.cinema_id = this.ruleInfo.cinema_scope
            }
            // 影院分类
            if (this.ruleInfo.class_scope !== undefined && this.ruleInfo.class_scope.length > 0) {
                data.class_scope_type = this.ruleInfo.class_scope_type
                data.class_scope = this.ruleInfo.class_scope
            } else {
                data.class_scope_type = 1
                data.class_scope = []
            }
            console.log(this.ruleInfo.include_hall_scope)

            // 影厅
            // if (this.ruleInfo.include_hall_scope !== undefined && this.ruleInfo.include_hall_scope.length > 0) {
            //     data.hall_scope_type = 2
            //     data.hall_name = this.ruleInfo.include_hall_scope
            // } else if (this.ruleInfo.exclude_hall_scope !== undefined && this.ruleInfo.exclude_hall_scope.length > 0) {
            //     data.hall_scope_type = 3
            //     data.hall_name = this.ruleInfo.exclude_hall_scope
            // }
            // console.log(this.ruleInfo.include_week_scope)
            if (this.configId === undefined || this.configId === 0) {
                // 新增
                data.type = this.configType

                Api.addConfig(data).then(res => {
                    this.isSaving = false;
                    this.$notify({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.goBack();
                }).catch(err => {
                    this.isSaving = false;
                    console.error('保存配置失败:', err);
                    this.$notify({
                        type: 'danger',
                        message: '保存失败，请重试'
                    });
                });

            } else {
                // 更新
                data.type = this.ruleInfo.type
                data.id = this.ruleInfo.id

                Api.updateConfig(data).then(res => {
                    this.isSaving = false;
                    this.$notify({
                        type: 'success',
                        message: '操作成功'
                    });
                    this.goBack();
                }).catch(err => {
                    this.isSaving = false;
                    console.error('更新配置失败:', err);
                    this.$notify({
                        type: 'danger',
                        message: '更新失败，请重试'
                    });
                });
            }
            } catch (error) {
                this.isSaving = false;
                console.error('保存配置过程中发生错误:', error);
                this.$notify({
                    type: 'danger',
                    message: '保存失败，请检查数据格式'
                });
            }
        },

    }
}
</script>

<style lang="scss" scoped>
.home-wrap {
    height: 100%;
    background-color: #f3f3f3;

    .main-card-wrap {
        background-color: white;
        -moz-box-shadow: 2px 2px 3px #ccc;
        -webkit-box-shadow: 2px 2px 3px #ccc;
        box-shadow: 2px 2px 3px #ccc;

        .left {
            .title {
                font-size: 16px;
            }

            .btn {
                height: 34px;
                width: 120px;
                color: white;
                margin-top: 6px;
                border-radius: 4px;
                background-color: #8565bd;
            }
        }

        .right {
            margin-right: 8px
        }
    }
}

.custom-checkbox {
    cursor: pointer;
    transition: color 0.3s, background-color 0.3s, border-color 0.3s;
    padding: 2px 8px;
    /* 根据需要调整内边距 */
    border: 1px solid #dcdfe6;
    /* 边框颜色 */
    border-radius: 8px;
    /* 圆角边框 */
    display: inline-block;
    /* 使元素内联显示 */
    line-height: 1.5;
    /* 行高 */
}

/* 选中状态样式 */
.custom-checkbox.checked {
    color: #1989fa;
    /* 选中时的文字颜色 */
    background-color: #ecf5ff;
    /* 选中时的背景颜色 */
    border-color: #1989fa;
    /* 选中时的边框颜色 */
}

.message {
    .van-field {
        border: 1px solid #e2e2e2;
        width: 90%;
        margin: 12px auto 28px auto;
        background: #f6f6f6;
    }
}

.bottom-row {
    position: absolute;
    bottom: 0;
    width: 100%;
}

/* 影院分类弹窗 - 简洁样式 */
.class-popup {
    background: #fff;
}
.class-popup-head {
    padding: 14px 16px 12px;
    border-bottom: 1px solid #ebedf0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.class-popup-title {
    font-size: 16px;
    font-weight: 600;
    color: #323233;
}
.class-popup-hint {
    font-size: 12px;
    color: #969799;
}
.class-popup-body {
    max-height: 50vh;
    min-height: 120px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
}
.class-popup-loading {
    padding: 48px 0;
    color: #969799;
    font-size: 13px;
}
.class-popup-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px;
    border-bottom: 1px solid #f5f6f8;
    font-size: 15px;
    color: #323233;
    transition: background 0.15s;
}
.class-popup-item:active {
    background: #f7f8fa;
}
.class-popup-item.is-checked {
    background: #f0f9eb;
    color: #07c160;
}
.class-popup-item-name {
    flex: 1;
}
.class-popup-item-icon {
    font-size: 18px;
    color: #07c160;
    margin-left: 8px;
}
.class-popup-empty {
    padding: 48px 16px;
    text-align: center;
    font-size: 14px;
    color: #969799;
}
.class-popup-foot {
    display: flex;
    padding: 12px 16px;
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
    gap: 10px;
    border-top: 1px solid #ebedf0;
    background: #fff;
}
.class-popup-btn {
    flex: 1;
    height: 40px;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s;
}
.class-popup-btn:active {
    opacity: 0.85;
}
.class-popup-btn--reset {
    background: #f2f3f5;
    color: #646566;
}
.class-popup-btn--exclude {
    background: #fff;
    color: #ee0a24;
    border: 1px solid #ee0a24;
}
.class-popup-btn--include {
    background: #07c160;
    color: #fff;
}

/* 院线选择颜色样式 */
.gpline-include {
    .van-cell__value {
        color: #07c160 !important; /* 选择绿色 */
    }
}

.gpline-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 选中状态优化 */
.custom-checkbox.checked {
    color: #1989fa;
    background-color: #ecf5ff;
    border-color: #1989fa;
    font-weight: bold;
}

/* 排除模式下的选中状态 */
.custom-checkbox.checked.exclude-mode {
    color: #ff2c54;
    background-color: #fff2f0;
    border-color: #ff2c54;
}

/* 底部统计信息样式 */
.bottom-row .van-col span {
    font-size: 14px;
}

.city-include {
    .van-cell__value {
        color: #07c160 !important; /* 包含绿色 */
    }
}

.city-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

.cinema-include {
    .van-cell__value {
        color: #07c160 !important; /* 包含绿色 */
    }
}

.cinema-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

.class-include {
    .van-cell__value {
        color: #07c160 !important; /* 包含绿色 */
    }
}

.class-exclude {
    .van-cell__value {
        color: #ff2c54 !important; /* 排除红色 */
    }
}

/* 按钮组样式优化 */
.button-group {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.action-btn {
    font-size: 13px !important;
    padding: 0 12px !important;
    min-width: 70px !important;
    height: 32px !important;
    white-space: nowrap;
    flex-shrink: 0;
}

/* 响应式按钮样式 */
@media screen and (max-width: 375px) {
    .action-btn {
        font-size: 12px !important;
        padding: 0 10px !important;
        min-width: 60px !important;
        height: 30px !important;
    }
    
    .button-group {
        gap: 10px;
    }
}

@media screen and (max-width: 320px) {
    .action-btn {
        font-size: 11px !important;
        padding: 0 8px !important;
        min-width: 55px !important;
        height: 28px !important;
    }
    
    .button-group {
        gap: 8px;
    }
}

/* 情侣座cell样式：标题弹性宽度，小屏适配 */
.couple-seat-cell {
    ::v-deep .van-cell__title {
        min-width: 80px;
        max-width: 35%;
        flex: none !important;
    }
    
    ::v-deep .van-cell__value {
        flex: 1 !important;
    }
}

/* 票数cell样式 */
.ticket-count-cell {
    ::v-deep .van-cell__title {
        min-width: 80px;
        max-width: 35%;
        flex: none !important;
    }
    
    ::v-deep .van-cell__value {
        flex: 1 !important;
    }
}
</style>